<template>
  <div class="panel-box">
    <h3 @click="isCollapse">
      眼动{{isSetting?'设置':'数据'}}
      <!-- <u-icon :name="showEyeMovementSetting ? 'ChevronDownMed' : 'ChevronRightMed'" /> -->
    </h3>
    <div :class="isSetting?'panel-setting':''"
         v-show="showEyeMovementSetting">
      <h4>运动模式: {{moveMode}}</h4>
      <div v-if="isSetting"
           class="radio">
        <input type="radio"
               v-model="moveMode"
               name="viewMode"
               value="随机"
               checked
               class="option-radio"
               id="option6">
        <label for="option6">随机</label>
        <input type="radio"
               v-model="moveMode"
               name="viewMode"
               value="逆时针"
               class="option-radio"
               id="option7">
        <label for="option7">逆时针</label>
        <input type="radio"
               v-model="moveMode"
               name="viewMode"
               value="顺时针"
               class="option-radio"
               id="option8">
        <label for="option8">顺时针</label>
      </div>
      <h4>运动速度:{{speed}}</h4>
      <u-slider v-if="isSetting"
                v-model="speed"
                :max="1.0"
                :min="0.1"
                :step="0.1" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isSetting: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    let eyemovement = this.$store.state.therapy.eyemovement
    return {
      moveMode: eyemovement.moveMode,
      speed: eyemovement.speed,
      showEyeMovementSetting: true,
    }
  },
  methods: {
    hasConfig(configName) {
      let g = this.$store.state.therapy.globalConfig
      return g.Eyemovement && g.Eyemovement.includes(configName)
    },
    isCollapse() {
      // this.showEyeMovementSetting = !this.showEyeMovementSetting
    },
  },
}
</script>



